import { Form, type FormItemProps, Input } from 'antd';

interface HiddenFormInputProps extends FormItemProps {
  disableValidation?: boolean;
  dataTestId?: string;
}

const HiddenFormInput = ({
  name = 'hiddenInput',
  rules,
  className,
  disableValidation,
  dataTestId,
  validateStatus,
}: HiddenFormInputProps) => {
  return (
    <Form.Item
      className={`hidden-form-input ${className || ''}`}
      name={name}
      rules={disableValidation ? [] : rules}
      id={name}
      data-testid={dataTestId}
      validateStatus={validateStatus}
    >
      <Input />
    </Form.Item>
  );
};

export default HiddenFormInput;
